<template>
  <el-dialog
    :title="$t('common.modify_pwd_dialog_title')"
    :visible.sync="dialogVisible"
    :show-close="dialogCloseable"
    lock-scroll
    :area="660"
    :close-on-click-modal="dialogCloseable"
    :close-on-press-escape="dialogCloseable"
    @open="dialogVisibleChange('open')"
    @close="dialogVisibleChange('close')"
  >
    <div class="m-modify-password-container">
      <modify-password-form
        ref="form"
        :show-old-pwd="dialogCloseable"
      ></modify-password-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="doModifyPwd"
      >{{$t('common.confirmBtn_text')}}</el-button>
      <el-button
        :disabled="!dialogCloseable"
        @click="dialogVisible = false"
      >{{$t('common.cancelBtn_text')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Api from 'api/api'
import ApiConfig from 'api/config'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
import util from 'utils/util'
import { mapMutations } from 'vuex'
import { encrypt } from '@hui-pro/utils'
import modifyPasswordForm from './modify-password-form.vue'
export default {
  name: 'need-modify-pwd',
  data () {
    return {
      dialogVisible: false,
      dialogCloseable: true
    }
  },
  methods: {
    ...mapMutations({ postMsgToActIframe: 'POST_MSG_TO_ACTIFRAME' }),
    dialogVisibleChange (state) {
      let params = { servFlag: 'tipSize', data: { loginOutConfirm: state === 'open' } }
      for (let i = 0; i < window.frames.length; i++) {
        window.frames[i].postMessage(JSON.stringify(params), '*')
      }
      if (state === 'open') {
        this.postMsgToActIframe('home')
      } else if (state === 'close') {
        let menuId = ''
        if (!util.isSystemConfiguration()) {
          // 在系统管理中 当前活动页id portal-sys-userName中，另外系统管理的iframe获取也用不到id
          // 所以直接 menuId= ""
          menuId = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
        }
        this.postMsgToActIframe(menuId)
      }
    },
    _modifyPwd (publicKey, data, loadingInstance) {
      data.newPassword = encrypt(publicKey, data.newPassword)
      data.newPasswordConfirm = encrypt(publicKey, data.newPasswordConfirm)
      data.oldPassword = encrypt(publicKey, data.oldPassword)
      data.publicKey = publicKey
      Api.common
        .modifyPwd(data)
        .then(res => {
          loadingInstance.close()
          this.$message.success(this.$t('common.modify_pwd_success'))
          this.dialogVisible = false
          window.location.href = ApiConfig.logoutSrc
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    _needModifyPwd () {
      Api.common
        .needModifyPwd()
        .then(res => {
          if (res.data) {
            this.modifyPwd(false)
          }
        })
    },
    modifyPwd (flag) {
      this.dialogCloseable = flag
      this.dialogVisible = true
      this.$refs.form && this.$refs.form.reset()
    },
    doModifyPwd () {
      let _data = this.$refs.form.getData()
      if (_data) {
        let _loadingInstance = this._getLoading()
        Api.common
          .getPublicKey()
          .then(res => {
            this._modifyPwd(res.data.publicKey, _data, _loadingInstance)
          })
          .catch(() => {
            _loadingInstance.close()
          })
      }
    }
  },
  mounted () {
    this._needModifyPwd()
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  components: {
    modifyPasswordForm
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.m-modify-password-container {
  width: 308px;
  margin: 0 auto;
}
</style>
